import React, { Component } from "react";
import "../css/route.css";
import {format_date_only, format_without_time} from '../Utils';
import {Form, Table } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';
import { RouteService } from "../Services/RouteService";
import { UserService } from "../Services/UserService";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Tooltip, IconButton, Icon, Grid, FormControlLabel, Switch } from "@material-ui/core";
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import moment from "moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { ROLES } from "../Roles";
import { RoleService } from "../Services/RoleService";

function getModalStyle() {
    const top = 50 ;
    const left = 50 ;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const styles = theme => ({
    fab: {
        margin: theme.spacing(1),
    },
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    paper: {
        position: 'absolute',
        width: theme.spacing(50),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
  });


class Route extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        rows: [],
        new_route: "",
        agents: [],
        show: false,
        showCreate: false,
        selectedAgent: {},
        selectedRoute: {},
        showMap: false,
        autoScheduling: false,
        roleMap: new Map()
      }

      this.handleChange = this.handleChange.bind(this);
      this.createRoute = this.createRoute.bind(this);
      this.removeRoute = this.removeRoute.bind(this);
      this.assignAgent = this.assignAgent.bind(this);
      this.removeAgentAssignment = this.removeAgentAssignment.bind(this);
      this.handleAssign = this.handleAssign.bind(this);
      //Modal
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      
      this.handleShowMap = this.handleShowMap.bind(this);
    }

    handleCloseAutoScheduling = () => {
        this.setState({autoScheduling: false, route: undefined});
    }

    handleShowAutoScheduling = (route) => e => {
        if(e)
            e.preventDefault();

        if(route){  
            route.auto_schedule_startdate = route.auto_schedule_startdate ? moment(route.auto_schedule_startdate): moment();
            this.setState({ autoScheduling: true, route: Object.assign({}, route)});
        } else {
            this.setState({ autoScheduling: true });
        }
    }

    handleClose() {
        this.setState({ show: false , selectedAgent: {}, selectedRoute: {}});
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleCloseCreate = ()  =>  {
        this.setState({ showCreate: false});
    }

    handleShowCreate = ()  => {
        this.setState({ showCreate: true });
    }

    handleShowMap() {
        let path = window.location.pathname;
        let index = path.lastIndexOf('/');
        path  = path.slice(index);
        window.open(path + "/routemap", "_blank");
    }
    
 
    componentDidMount(){
        RoleService.getRoleList()
        .then((data) => {
            let roleDetailMap = new Map();
            data.roles.forEach(role => {
                roleDetailMap.set(role.code, role);
            });

            this.setState({roleMap: roleDetailMap}, () => this.fetchData());
        });
        this.props.setTitle(`Routes - ${this.state.data.length}`);
    }

    fetchData(){
        this.props.isLoading(true);
        this.props.showProgressDialog('Finding Routes...');
        let rows = [];
        RouteService.getDetailedRoute()
        .then((data) => {
            console.log(data.routes);
            this.fetchAgents();
            data.routes.forEach((route) => {
                rows.push(<RouteDetails key={route.id} route={route} removeRoute={this.removeRoute} assignAgent={this.assignAgent} removeAgentAssignment={this.removeAgentAssignment} handleShowAutoScheduling={this.handleShowAutoScheduling}/>);
            });
            this.setState({data: data.routes, rows: rows}, () => this.props.setTitle(`Routes - ${this.state.data.length}`));
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        });
    }

    fetchAgents(){
        UserService.getAgentList()
        .then((data) => {
            console.log(data);
            this.setState({agents: data.users});
        })
        .catch(error => console.log(error));
    }

    handleChange(e) {
        this.setState({ new_route: e.target.value });
    }

    handleChangeScheduling = (event) => {
        let value = event.target.checked;
        let key = event.target.name;

        let route = this.state.route;
        if(key === 'auto_schedule_pattern'){
            route[key] = value ? "DAILY" : "ALTERNATE" ;
        } else if(key === 'auto_schedule_enabled'){
            route[key] = value ? "1" : "0"
        }
        this.setState({route});
    }

    handleChangeStartDate = (date) => {
        this.setState(prevState => ({
            route: {
                ...prevState.route,
                auto_schedule_startdate: date
            }
        }));
    }

    createRoute(e){
        e.preventDefault();
        this.props.showConfirmDialog("WOW! Visibility increased. Create route?", 'New Route', () => {
            this.createRouteAPI(this.state.new_route);
            this.props.closeConfirmDialog();
        });
    }

    removeRoute(e, route){
        console.log("Remove route request: " + route.id);
        this.props.showConfirmDialog("Confirm removal of Route?", 'Remove Route', () => {
            RouteService.removeRoute(route.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                this.props.showSnackBar('Removed Route', 'success');
                this.fetchData();
            })
            .catch((error) => {
                this.props.showConfirmDialog("Cannot remove, as the route is assigned to an Agent or Store.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }

    removeAgentAssignment(e, route){
        e.preventDefault();
        console.log("Remove agent assignment for route: " + route.id);
        this.props.showConfirmDialog("Confirm removal of agent assignment?", undefined, () => {
            RouteService.removeAgentAssigned(route.id, route.agent_id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                this.props.showSnackBar('Removed Route Assignment', 'success');
                this.fetchData();
            })
            .catch((error) => {
                this.props.showConfirmDialog("Cannot remove assignment. Please try again later.", undefined, undefined);
            });
            this.props.closeConfirmDialog();
        });
    }

    assignAgent(e, route, isAgentAssigned) {
        this.handleShow();
        if(isAgentAssigned){
            let agent = this.state.agents.filter((agent) => {
                return agent.id === route.agent_id;
            });
            if(agent)
                this.setState({selectedAgent: agent});
        }
        this.setState({selectedRoute: route});
    }

    handleAssign(){
        console.log(this.state.selectedAgent.id );
        let body = {
                    route_id: this.state.selectedRoute.id, 
                    user_id: this.state.selectedAgent.id 
                };
        console.log( JSON.stringify(body));
        RouteService.assignRouteToAgent(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            this.props.showSnackBar('Route Assigned', 'success');
            console.log(data);
            this.handleClose();
            this.fetchData();
        })
        .catch((error) => {
            console.log(error);
            this.props.showConfirmDialog("Something went wrong. Please check again later.", undefined, undefined);
        });
    }

    handleScheduling = () => {
        let oldValue = this.state.data.filter(r => r.id === this.state.route.id);
        let route = this.state.route;
        console.log(oldValue, route)
        if(oldValue.length === 1 && oldValue[0].auto_schedule_enabled === route.auto_schedule_enabled && oldValue[0].auto_schedule_pattern === route.auto_schedule_pattern && oldValue[0].auto_schedule_startdate === route.auto_schedule_startdate) {
            this.props.showSnackBar("No changes made", "warning");
        } else {
            this.props.showConfirmDialog("Confirm change to scheduling pattern", "Warning", () => {
                this.confirm(route);
            });
        }
    }

    confirm = (route) => {
        let body = route;
        body.auto_schedule_startdate = moment(route.auto_schedule_startdate).format(format_without_time);
        let headers = {"user-id" : this.props.user.id, 'user-name': this.props.user.name};
        RouteService.schedulingChanges(body, headers)
        .then((response) => {
            console.log(response);
            this.props.showSnackBar('Made changes to scheduling pattern of Route', 'success');
            this.props.isLoading(false);
            this.fetchData();
            this.handleCloseAutoScheduling();
        })
        .catch(() => {
            this.props.isLoading(false);
            this.props.showConfirmDialog(`Failed to update scheduling pattern changes. Please try again.`, undefined, undefined);
        });
        this.props.closeConfirmDialog();
    }

    createRouteAPI(route_name){
        let body = {name: route_name};
        RouteService.createRoute(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
        .then((data) => {
            console.log(data);
            this.props.showSnackBar('Route Created', 'success');
            this.setState({
                new_route: ""
            });
            this.fetchData();
            this.handleCloseCreate();
        })
        .catch((error) => {
            console.log(error);
            this.props.showConfirmDialog("Route already exists. Please check again.", undefined, undefined);
        });
        
    }
    
    render() {
        let {route} = this.state;
        return (
            <div className="Home route">
                {   this.props.modules_enabled.customer_app_options &&
                    <Button variant="outlined" type="submit" style={{marginLeft:"10px"}} onClick={this.handleShowMap}>Show Map</Button>
                }
                <div className="">
                    <Paper style={{width: "100%", marginTop: "10pt", paddingTop : '15px', paddingLeft: "5px", paddingRight: "5px", marginBottom: 100}}>
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>Route</th>
                                    <th>Agent</th>
                                    <th>Auto Scheduling configuration</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.rows}
                            </tbody>
                        </Table>
                    </Paper>
                </div>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.showCreate} 
                    onClose={this.handleCloseCreate}>
                    <div style={getModalStyle()} className={this.props.classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            Create Route
                        </Typography>
                        <Divider />
                        <Form inline className="route" onSubmit={this.createRoute}>
                            <TextField
                                id="new_route"
                                className={this.props.classes.textField}
                                variant="outlined"
                                label="Route"
                                margin="normal"
                                defaultValue={this.state.new_route}
                                name="new_route"
                                onChange={this.handleChange}
                                pattern="[0-9]*"
                                type="text"
                                required />
                            {/* <HelpBlock>Please enter Route name as per DailyNinja</HelpBlock> */}
                            {'    '}
                            <div style={{marginTop: "10px"}}>
                                <Button variant="outlined" size="medium" style={{marginRight: "10px"}} color="primary" onClick={this.handleCloseCreate}>Close</Button>
                                <Button variant="outlined" size="medium" color="primary" type="submit" onClick={this.createRoute} autoFocus>Create Route</Button>
                            </div>
                        </Form>
                    </div>
                </Modal>
                <Modal 
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.show} 
                    onClose={this.handleClose}>
                    <div style={getModalStyle()} className={this.props.classes.paper}>
                        <Typography variant="h6" id="modal-title">
                            Assign Agent
                        </Typography>
                        <Divider />
                        <Typeahead
                            id="typeahead-id-route"
                            onChange={(selected) => {
                                this.setState({ selectedAgent: selected[0] });
                            }}
                            options={this.state.agents.filter(a => a.status === '1' && (a.roles.includes(this.state.roleMap.get(ROLES.DELIVERY_AGENT).id) || a.roles.includes(this.state.roleMap.get(ROLES.SUPER_AGENT).id) || a.roles.includes(this.state.roleMap.get(ROLES.ADMIN).id)))}
                            labelKey="name"
                            placeholder="Choose an Agent"
                            clearButton
                            //defaultSelected ={this.state.selectedAgent}
                        />
                        <div style={{marginTop: "10px"}}>
                            <Button variant="outlined" size="medium" color="primary" type="submit" onClick={this.handleAssign} style={{marginRight: "10px"}}>Assign</Button>
                            <Button variant="outlined" size="medium" color="primary" onClick={this.handleClose}>Close</Button>
                        </div>
                    </div>
                </Modal>
                <Fab variant="extended" onClick={this.handleShowCreate} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '86.5%'}}>
                    <AddIcon />
                    Add Route
                </Fab>
                {route && 
                <DialogMUI
                    fullWidth
                    maxWidth="md"
                    disableEscapeKeyDown
                    open={this.state.autoScheduling}
                    onClose={this.handleCloseAutoScheduling}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Auto Scheduling - {route.name}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Divider />
                                <Grid container>
                                    <Grid item xs={6}>
                                        Status:
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControlLabel 
                                            control={
                                                <Switch
                                                    checked={route.auto_schedule_enabled === "1" ? true : false}
                                                    value="auto_schedule_enabled"
                                                    color="primary"
                                                    name="auto_schedule_enabled"
                                                    onChange={this.handleChangeScheduling}
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            }
                                            label={route.auto_schedule_enabled === "1" ? "Enabled" : "Disabled"} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        Pattern:
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControlLabel 
                                            disabled={route.auto_schedule_enabled === "0"}
                                            control={
                                                <Switch
                                                    checked={route.auto_schedule_pattern === "DAILY" ? true : false}
                                                    value="auto_schedule_pattern"
                                                    color="primary"
                                                    name="auto_schedule_pattern"
                                                    onChange={this.handleChangeScheduling}
                                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                                />
                                            }
                                            label={route.auto_schedule_enabled === "1" ? (route.auto_schedule_pattern) : ''} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        Start Date:
                                    </Grid>
                                    <Grid item xs={6}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                variant="dialog"
                                                inputVariant="outlined"
                                                margin="normal"
                                                label="From"
                                                value={route.auto_schedule_startdate}
                                                onChange={this.handleChangeStartDate}
                                                format='DD MMM YYYY'
                                                minDate={moment()}
                                                InputLabelProps={{
                                                    style: { zIndex: 'auto' }
                                                }}
                                                style={{height: "100%", marginTop: "24px"}}
                                                minDateMessage=""
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseAutoScheduling} color="primary" autoFocus>
                                Close
                            </Button>
                            <Button variant="outlined" size="medium" color="primary" type="submit" onClick={this.handleScheduling} style={{marginRight: "10px"}}>
                                Schedule Changes
                            </Button>
                        </DialogActions>
                </DialogMUI>
                }
            </div>
        );
    }

}

class RouteDetails extends Component {

    render(){
        const route = this.props.route;
    //   const format = 'YYYY-MM-DD HH:mm:SS';
    //   const time = moment(location.time, format);
        const isAgentAssigned = route.agent_name !== null;
        return (
            <tr className={isAgentAssigned ? "" : "warning"}>
                <td>{route.name}</td>
                <td>
                    {route.agent_name}
                </td>
                <td>
                    <Typography variant="subtitle1">
                        <React.Fragment>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" style={{fontSize: 16}}>
                                        Status:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1" color={route.auto_schedule_enabled === '0' ? 'secondary' : 'primary'}>
                                        {route.auto_schedule_enabled === '0' ? 'Disabled' : 'Enabled'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" style={{fontSize: 16}}>
                                        Pattern:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    {route.auto_schedule_enabled === '1' ? route.auto_schedule_pattern : '-'}
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" style={{fontSize: 16}}>
                                        Start date:
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    {route.auto_schedule_startdate ? moment(route.auto_schedule_startdate).format(format_date_only) : '-'}
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    </Typography>
                </td>
                <td>
                    <Tooltip title="Remove Route">
                        <IconButton aria-label="Remove Route" style={{marginRight: "10px"}} onClick={(e) => this.props.removeRoute(e,route)}>
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>
                    {/* <OverlayTrigger placement="bottom" overlay={tooltip("Remove Route")}>
                        <Glyphicon glyph="trash" />
                    </OverlayTrigger> */}
                    <Tooltip title={isAgentAssigned ? "Reassign" : "Assign"}>
                        <IconButton aria-label={isAgentAssigned ? "Reassign" : "Assign"} style={{marginRight: "10px"}} onClick={(e) => this.props.assignAgent(e, route, isAgentAssigned)}>
                            <Icon>person</Icon>
                        </IconButton>
                    </Tooltip>
                    {/* <OverlayTrigger placement="bottom" overlay={tooltip()}>
                        <Glyphicon glyph="user" style={{marginRight: "10px"}} onClick={}/>
                    </OverlayTrigger> */}
                    {/* <OverlayTrigger placement="bottom" overlay={tooltip("Remove Assignment")}>
                                <Glyphicon glyph="remove" style={{marginRight: "10px"}} onClick={(e) => this.props.removeAgentAssignment(e, route)}/>
                            </OverlayTrigger> */}
                    { isAgentAssigned ? (
                            <Tooltip title="Remove Assignment">
                                <IconButton aria-label="Remove Assignment" style={{marginRight: "10px"}} onClick={(e) => this.props.removeAgentAssignment(e, route)}>
                                    <Icon>cancel</Icon>
                                </IconButton>
                            </Tooltip>
                        ) : null
                    }
                    { isAgentAssigned ? (
                            <Tooltip title="Manage Schedule">
                                <IconButton aria-label="Manage Schedule" onClick={this.props.handleShowAutoScheduling(route)}>
                                    <Icon>schedule</Icon>
                                </IconButton>
                            </Tooltip>
                        ) : null
                    }
                </td>
            </tr>
        );
    }
}

export default withStyles(styles)(Route);